<template>
  <div class="role-list">
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="8" class="col8">
          <span>角色名:</span>
          <el-input placeholder="角色名检索" v-model="queryInfo.form.name" clearable @clear="getRoleList">
          </el-input>
        </el-col>
        <el-col :span="8" class="col8">
          <span>角色编码:</span>
          <el-input placeholder="角色编码检索" v-model="queryInfo.form.code" clearable @clear="getRoleList">
          </el-input>
        </el-col>

        <el-button type="primary" v-on:click="getRoleList">查询</el-button>
        <el-button type="primary" @click="addDialogVisible = true">新增角色</el-button>
      </el-row>
      <el-row class="btns">

      </el-row>

      <!-- 角色列表区域 -->
      <el-table :data="roleList" border stripe>
        <el-table-column label="序号" prop="id" width="50px" type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="角色名" prop="name"></el-table-column>
        <el-table-column label="角色编码" prop="code"></el-table-column>
        <el-table-column label="描述" prop="desc"></el-table-column>
        <el-table-column label="操作" width="300px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)" v-has='"btn_role_del"'>删除</el-button>
            <!-- 分配权限按钮 -->
            <el-tooltip effect="dark" content="权限配置" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-setting" size="mini" @click="setPermission(scope.row)">配置权限</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page" :page-sizes="[20, 50, 100, 200]" :page-size="queryInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加角色的对话框 -->
    <el-dialog title="添加角色" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed" :close-on-click-modal='false' >
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="formRules" ref="addFormRef" label-width="110px">

        <el-form-item label="角色名" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="code">
          <el-input v-model="addForm.code" type="code"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="desc">
          <el-input v-model="addForm.desc" type="desc"></el-input>
        </el-form-item>

      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRole">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 修改角色信息的对话框 -->
    <el-dialog title="修改角色信息" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed" :close-on-click-modal='false' >
      <el-form :model="editForm" :rules="formRules" ref="editFormRef" label-width="110px">

        <el-form-item label="角色名" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="code">
          <el-input v-model="editForm.code" type="code"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="desc">
          <el-input v-model="editForm.desc" type="desc"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editRole">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 分配权限的对话框 -->
    <el-dialog title="分配权限" :visible.sync="setPermissionDialogVisible" width="50%" @close="setPermissionDialogClosed">
      <el-tree :data="permissionList" show-checkbox :check-strictly='true' :default-checked-keys="keys" ref="tree" node-key="id" :props="defaultProps"></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPermissionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePermissionInfo">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import * as roleApi from '../../api/roleAPI'
import * as permissionApi from '../../api/permissionAPI'
import * as rolePermissionApi from '../../api/rolePermissionAPI'
export default {
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfo: {
        form: {
          name: '',
          id: '',
          status: ''
        },
        // 当前的页数
        page: 1,
        // 当前每页显示多少条数据
        size: 20,
        name: 'SYS_ROLE'
      },
      roleList: [],
      total: 0,
      // 控制添加角色对话框的显示与隐藏
      addDialogVisible: false,
      setPermissionDialogVisible: false,
      percentage: 0,
      // 添加角色的表单数据
      addForm: {
        name: '',
        code: '',
        desc: ''
      },
      formRules: {
        code: [{ required: true, message: "请输入角色编码", trigger: "blur", },],
        name: [{ required: true, message: "请输入角色名", trigger: "blur", },],
      },
      // 控制修改角色对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
      },
      // 需要被分配角色的用户信息
      roleInfo: {},
      // 已选中的角色Id值
      selectedRoleId: '',
      permissionList: [],
      keys: [66],
      defaultProps: {
        children: "children",
        label: "name"
      },
    }
  },
  created() {
    this.getRoleList()
    this.getPermissionList()
  },
  methods: {
    async getRoleList() {
      let param = { ...this.queryInfo }
     
      console.log(param);
      let res = await roleApi.findAll(param)
      if (res.flag) {
        console.log(res);
        this.roleList = res.data.list
        this.total = res.data.total
      }

    },
   async getPermissionList(){
     
      let res = await permissionApi.findAll()
      if(res.flag){
        let firstList = res.data.filter(item=>item.type=='1stMenu')
        this.initTree(firstList,res.data)
        this.permissionList = firstList
      }
    },
    initTree(list,all){
      list.forEach(item=>{
        let children = all.filter(item1=>item1.pid==item.id)
        this.initTree(children,all)
        item.children = children
      })
    },
    // 监听 size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.size = newSize
      this.getRoleList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.page = newPage
      this.getRoleList()
    },

    // 监听添加角色对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮，添加新角色
    addRole() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let from = { ...this.addForm }
        roleApi.save(from).then(res => {
          if (res.flag) {
            this.$message.success('添加角色成功！')
            this.getRoleList()
            this.addDialogVisible = false
          }
        })
      })
    },
    // 展示编辑项目的对话框
    showEditDialog(user) {
      this.editForm = { ...user }
      this.editDialogVisible = true
    },
    // 监听修改项目对话框的关闭事件
    editDialogClosed() {
      //this.$refs.addFormRef.resetFields()
      this.editForm = {}
    },
    // 修改信息并提交
    editRole() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let {  ...from } = this.editForm 
        roleApi.update(from).then(res => {
          if (res.flag) {
            this.$message.success('更新角色信息成功！')
            this.getRoleList()
            this.editDialogVisible = false
          }
        })
      })
    },
    // 根据Id删除对应的角色信息
    async removeById(id) {
      // 弹框询问角色是否删除数据
      const confirmResult = await this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      roleApi.del(id).then(res => {
        if (res.flag) {
          this.$message.success('删除角色成功！')
          this.getRoleList();
        }
      })

    },
    // 监听分配角色对话框的关闭事件
    setPermissionDialogClosed() {
      this.selectedRoleId = ''
      this.$refs.tree.setCheckedKeys([])
      this.roleInfo = {}
    },
    async savePermissionInfo() {
      var list=[...this.$refs.tree.getCheckedKeys(),...this.$refs.tree.getHalfCheckedKeys()]
      console.log(list);
      let addList = list.filter(t=>!this.keys.includes(t))
      let delList = this.keys.filter(t=>!list.includes(t))
      for (let i = 0; i < addList.length; i++) {
        const add = addList[i];
        let param ={ 'roleId': this.roleInfo.id, 'permissionId':add }
        await rolePermissionApi.save(param)
      }
      for (let i = 0; i < delList.length; i++) {
        const del = delList[i];
        let param ={ 'roleId': this.roleInfo.id , 'permissionId':del }
        await rolePermissionApi.del(param)
      }
      this.$message.success('权限配置成功')
      this.getPermissionList()
      this.setPermissionDialogVisible = false

    },
    // 展示分配角色的对话框
    async setPermission(roleInfo) {
      this.roleInfo = roleInfo    
      let res = await rolePermissionApi.findByRoleId(roleInfo.id)
      if(res.flag){
        /**
         * 判断是否有子节点
         * 没有子节点 直接选中
         * 有子节点 判断是否全选
         * 子节点全选 父节点也选中
         * 子节点未全选中 父节点不选中
         */
        this.keys = res.data.map(rp=>rp.permissionId)
      }  
      this.setPermissionDialogVisible = true
    },
       indexMethod(index){
      return (this.queryInfo.page-1)*this.queryInfo.size+index+1
    }

  },

}
</script>

<style lang="less" >
.role-list {
  .col8 {
    display: flex;
    white-space: nowrap;
    align-items: center;
    font-size: 14px;
    color: #606266;
    > span {
      width: 120px;
      text-align: center;
    }
    .el-select {
      width: 100%;
    }
  }
  .btns {
    text-align: end;
    button {
      margin-top: 20px;
    }
  }

  .el-form-item.col2 {
    .el-form-item__content {
      display: flex;
      .el-input {
        width: 230px;
      }
    }
  }
  .el-dialog {
    min-width: 720px;
  }
  .header-list {
    display: flex;
    padding-left: 0px;
    flex-wrap: wrap;
    .header-item {
      margin-left: 20px;
      margin-bottom: 20px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      img {
        width: 60px;
      }
      .el-icon-check {
        display: none;
      }
    }
    .header-item.clicked {
      border: 2px solid #5fbdfe;
      // ::before {
      //    width:0;
      //   height:0;
      //   border-width:50px;
      //   border-style:solid;
      //   border-top-left-radius: 15px;
      //   opacity: 0.569;
      //   border-color:red transparent transparent red;
      // }
      .el-icon-check {
        display: block;
        position: absolute;
        font-size: 30px;
        font-weight: bolder;
        color: #10ff00;
        bottom: -6px;
        right: -2px;
      }
    }
  }
}
</style>
